export enum SmokerStatus {
    Smoker = "Smoker",
    NonSmoker = "Non-Smoker",
    Unknown = "Unknown"
}
